import { useState } from "react";

interface ITodayLuckRow {
  something: string;
  somethingClass: string;
  color: string;
  content: string | number;
  onClickRow?: () => void;
}

const TodayLuckRow = ({
  something,
  somethingClass,
  color,
  content,
  onClickRow,
}: ITodayLuckRow) => {
  return (
    <div className={`today_luck_row ${somethingClass}`}>
      <div className="left">
        <span className="icon"></span>
        행운의 <span className="today_luck_bold">{something}</span>
      </div>
      <div className="right">
        <span
          onClick={onClickRow}
          className={`today_color ${color} ${
            content === "확인하기" ? "clickable" : ""
          }`}
        >
          {content}
        </span>
      </div>
    </div>
  );
};

const TodayLuck = ({
  color,
  gift,
  giftKey,
  food,
  foodKey,
  number,
}: {
  color: string;
  gift: string;
  giftKey: string;
  food: string;
  foodKey: string;
  number: number;
}) => {
  const colorObj: { [key: string]: string } = {
    red: "빨간색",
    orange: "주황색",
    yellow: "노란색",
    green: "초록색",
    blue: "파란색",
    navy: "남색",
    purple: "보라색",
    white: "흰색",
    black: "검은색",
  };

  const [giftContent, setGiftContent] = useState<string>("확인하기");
  const [foodContent, setFoodContent] = useState<string>("확인하기");

  const onClickGift = () => {
    window.open(gift, "_blank");
    setTimeout(() => {
      setGiftContent(giftKey);
    }, 300);
  };

  const onClickFood = () => {
    window.open(food, "_blank");
    setTimeout(() => {
      setFoodContent(foodKey);
    }, 300);
  };

  return (
    <div className="all_luck_wrapper" style={{ marginTop: 60 }}>
      <div className="all_luck_title" style={{ marginBottom: 28 }}>
        <span className={`today_color ${color}`}>오늘의 행운</span>을
        확인하세요!
      </div>
      <TodayLuckRow
        something="색상"
        somethingClass="color"
        color={color}
        content={colorObj[color]}
      />
      <TodayLuckRow
        something="물건"
        somethingClass="gift"
        color={color}
        content={giftContent}
        onClickRow={onClickGift}
      />
      <TodayLuckRow
        something="음식"
        somethingClass="food"
        color={color}
        content={foodContent}
        onClickRow={onClickFood}
      />
      <TodayLuckRow
        something="숫자"
        somethingClass="number"
        color={color}
        content={number}
      />
    </div>
  );
};

export default TodayLuck;
